export default {
  getter: (property, prefixed = true) => localStorage.getItem(prefixed ? `credere:embed:${property}` : property),
  setter: (property, value, prefixed = true) => localStorage.setItem(prefixed ? `credere:embed:${property}` : property, value),
};
